module.exports = __webpack_public_path__ + "img/tips1_botlist7img4.882f8a2e.png";